/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PaymentMethodItem
 */
export interface PaymentMethodItem {
  /**
   *
   * @type {string}
   * @memberof PaymentMethodItem
   */
  stripePaymentMethodId: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodItem
   */
  cardholderName: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodItem
   */
  brand: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodItem
   */
  lastFourDigits: string;
  /**
   *
   * @type {boolean}
   * @memberof PaymentMethodItem
   */
  companyDefault: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodItem
   */
  expiry?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PaymentMethodItem
   */
  currentlySelectedForShipment: boolean;
}

/**
 * Check if a given object implements the PaymentMethodItem interface.
 */
export function instanceOfPaymentMethodItem(
  value: object,
): value is PaymentMethodItem {
  if (
    !("stripePaymentMethodId" in value) ||
    value["stripePaymentMethodId"] === undefined
  )
    return false;
  if (!("cardholderName" in value) || value["cardholderName"] === undefined)
    return false;
  if (!("brand" in value) || value["brand"] === undefined) return false;
  if (!("lastFourDigits" in value) || value["lastFourDigits"] === undefined)
    return false;
  if (!("companyDefault" in value) || value["companyDefault"] === undefined)
    return false;
  if (
    !("currentlySelectedForShipment" in value) ||
    value["currentlySelectedForShipment"] === undefined
  )
    return false;
  return true;
}

export function PaymentMethodItemFromJSON(json: any): PaymentMethodItem {
  return PaymentMethodItemFromJSONTyped(json, false);
}

export function PaymentMethodItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaymentMethodItem {
  if (json == null) {
    return json;
  }
  return {
    stripePaymentMethodId: json["stripePaymentMethodId"],
    cardholderName: json["cardholderName"],
    brand: json["brand"],
    lastFourDigits: json["lastFourDigits"],
    companyDefault: json["companyDefault"],
    expiry: json["expiry"] == null ? undefined : json["expiry"],
    currentlySelectedForShipment: json["currentlySelectedForShipment"],
  };
}

export function PaymentMethodItemToJSON(json: any): PaymentMethodItem {
  return PaymentMethodItemToJSONTyped(json, false);
}

export function PaymentMethodItemToJSONTyped(
  value?: PaymentMethodItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    stripePaymentMethodId: value["stripePaymentMethodId"],
    cardholderName: value["cardholderName"],
    brand: value["brand"],
    lastFourDigits: value["lastFourDigits"],
    companyDefault: value["companyDefault"],
    expiry: value["expiry"],
    currentlySelectedForShipment: value["currentlySelectedForShipment"],
  };
}
